module.exports = __webpack_public_path__ + "img/video-refresh.1aa1988a.png";